import { ConfigProvider } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Routes from '../../routers/routes';
import { storeName } from '../../store/models/layout.model';
import {
  CLIENT_FORGOT_PASSWORD_LINK,
  CLIENT_REGISTER_NOTIFY_VERIFY_EMAIL_LINK,
  CLIENT_RESET_PASSWORD_PAGE_LINK,
  CLIENT_SIGN_UP_LINK,
} from '../../commons/constants/links';
import { detectDevice } from '../../utils';
import Loading from './Loading';
import SplashScreen from './SplashScreen';
import './styles.scss';

const NO_SPLASH_PATHS = [
  CLIENT_SIGN_UP_LINK,
  CLIENT_FORGOT_PASSWORD_LINK,
  CLIENT_RESET_PASSWORD_PAGE_LINK,
  CLIENT_REGISTER_NOTIFY_VERIFY_EMAIL_LINK,
];

const Layout: FC = () => {
  const skipSplash = NO_SPLASH_PATHS.includes(window.location.pathname);
  const [waitAuthCheck, setWaitAuthCheck] = useState<boolean>(!skipSplash);

  const dispatch = useDispatch()[storeName];

  useEffect(() => {
    if (skipSplash) {
      dispatch.setLoading(false);
    } else {
      setTimeout(() => {
        setWaitAuthCheck(false);
      }, 1000);
    }

    const isMobile = detectDevice();
    if (isMobile) dispatch.setMobileDevice(true);
  }, []);

  if (waitAuthCheck) return <SplashScreen />;

  return (
    <div className="clik-account__layout">
      <Loading />
      <ConfigProvider>
        <Routes />
      </ConfigProvider>
    </div>
  );
};

export default Layout;
